export const getUrlParameter = () => {
    const parts = window.location.pathname.split('/');
    return parts[parts.length - 1].split('?')[0];
};
